import { Link } from "react-router-dom";
import { SERVICES, PRODUCTS } from "../data/services";

export const Footer = () => (
  <footer className="bg-primary text-white" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-2">
            <img src="/assets/logo-icon.png" alt="Anxya Tech logo" className="h-9 w-9 object-contain" />
            <span className="font-display font-semibold tracking-tight text-lg">
              Anxya<span className="text-accent">Tech</span>
            </span>
          </div>
          <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-xs">
            Healthcare Products, Solutions and Services — from bioinformatics and genomics to patient experience, engineered for clinical trust.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-accent">Services</p>
          <ul className="mt-5 space-y-2.5">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-sm text-white/70 hover:text-accent transition-colors">
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-accent">Products</p>
          <ul className="mt-5 space-y-2.5">
            {PRODUCTS.map((p) => (
              <li key={p.slug}>
                <Link to={`/products/${p.slug}`} className="text-sm text-white/70 hover:text-accent transition-colors" data-testid={`footer-product-${p.slug}`}>
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-accent">Company</p>
          <ul className="mt-5 space-y-2.5 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-accent transition-colors">About Us</Link></li>
            <li><Link to="/universal-ai-os" className="hover:text-accent transition-colors" data-testid="footer-universal-platform-link">Anxya AI OS & PaaS</Link></li>
            <li><Link to="/story" className="hover:text-accent transition-colors" data-testid="footer-story-link">Our Story</Link></li>
            <li><Link to="/why-anxya" className="hover:text-accent transition-colors" data-testid="footer-why-anxya-link">Why Anxya</Link></li>
            <li><Link to="/insights" className="hover:text-accent transition-colors">Insights</Link></li>
            <li><Link to="/careers" className="hover:text-accent transition-colors">Careers</Link></li>
            <li><Link to="/pitch" className="hover:text-accent transition-colors" data-testid="footer-pitch-link">Pitch Deck</Link></li>
            <li><Link to="/domains" className="hover:text-accent transition-colors" data-testid="footer-domains-link">Domains & Hosting</Link></li>
            <li><Link to="/contact" className="hover:text-accent transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-accent">Reach Us</p>
          <ul className="mt-5 space-y-2.5 text-sm text-white/70">
            <li>contact[at]anxya.tech</li>
            <li>+91-6398009260</li>
            <li>Pune (HQ) · Mumbai</li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/40">© 2026 Anxya Tech Pvt. Ltd. All rights reserved.</p>
        <p className="text-xs text-white/40">One platform. Every industry. Every jurisdiction.</p>
      </div>
    </div>
  </footer>
);
